import { Box, Skeleton, VStack } from 'native-base';
import React, { memo } from 'react';
const LoanOverviewSkeleton = _ref => {
  let {
    dataTestID
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    testID: dataTestID,
    borderColor: "gray.200",
    borderLeftWidth: 8,
    borderWidth: 1,
    borderRadius: "md",
    p: "4",
    flex: {
      lg: 1
    },
    maxH: "32"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 6
  }, /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 1,
    maxW: "25%"
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 3,
    maxW: "55%"
  })));
};
export default /*#__PURE__*/memo(LoanOverviewSkeleton);
//# sourceMappingURL=index.js.map